const app_base_url = "/itbi";

const base_url_api = "https://solucoes.sinsoft.com.br/api/itbi";
//const base_url_api = "http://localhost:7335";


const app_full_url = "https://solucoes.sinsoft.com.br/itbi";
//const app_full_url = "http://localhost:3000/itbi"
//
const base_url_enderecos_api = "https://solucoes.sinsoft.com.br/api/enderecos";

const base_url_unico_api = "https://solucoes.sinsoft.com.br/api/itbi-sql-server";
//const base_url_unico_api = "http://localhost:7375";


const baseUrlApiNotoficacoes = "https://solucoes.sinsoft.com.br/api/itbi-notificacoes-redifinicoes"//"https://localhost:7365"
//const baseUrlApiNotoficacoes = "http://localhost:7365";

const app_server = "https://solucoes.sinsoft.com.br";

//const app_server = "http://localhost:3000";

const base_url_api_comunicacao = "https://solucoes.sinsoft.com.br/api/itbi-messages"

//const base_url_api_comunicacao = "http://localhost:7355"

export const baseUrlSocket = "https://solucoes.sinsoft.com.br"
//export const baseUrlSocket = "http://localhost:7355";
export const pathSocket = "/api/itbi-messages/socket.io"
//export const pathSocket = "/socket.io"

const api_pix = "https://solucoes.sinsoft.com.br/api/pix/auxPix";

export { app_base_url, base_url_api, base_url_enderecos_api, base_url_unico_api, app_server, base_url_api_comunicacao, app_full_url, baseUrlApiNotoficacoes, api_pix };
//baseUrlApiNotoficacoes